import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const ColorPalettesRow = dt7948.c(class ColorPalettesRow extends SelectKitRowComponent {
  get palettes() {
    return htmlSafe((this.item.colors || []).filter(color => color.name !== "secondary").map(color => `#${escape(color.hex)}`).map(hex => `<span class="palette" style="background-color:${hex}"></span>`).join(""));
  }
  static {
    dt7948.n(this.prototype, "palettes", [computed("item.colors.[]")]);
  }
  get backgroundColor() {
    const secondary = (this.item.colors || []).find(color => color.name === "secondary");
    if (secondary && secondary.hex) {
      return htmlSafe(`background-color:#${escape(secondary.hex)}`);
    } else {
      return "";
    }
  }
  static {
    dt7948.n(this.prototype, "backgroundColor", [computed("item.colors.[]")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <span class=\"name\">\n      {{this.label}}\n    </span>\n\n    {{#if this.item.colors}}\n      <div class=\"palettes\" style={{this.backgroundColor}}>\n        {{this.palettes}}\n      </div>\n    {{/if}}\n  ", {
      strictMode: true
    }), this);
  }
}, [classNames("color-palettes-row")]);
export default ColorPalettesRow;